export default {
    connect: 'connect',
    disconnect: 'disconnect',
    reconnectAttempt: 'reconnect_attempt',
    error: 'error',
    subTopic: 'sub-topic',
    unsubTopic: 'unsub-topic',
    // v0.6.0부터 사용
    // 관련문서: https://www.notion.so/barogohq/Client-Push-Name-Space-Room-Event-29cdeb63219342bb931f5d9fd9c03c4d
    roomUpdatedHubTopic: 'room-updated-hub',
    roomUpdatedDistributorTopic: 'room-updated-distributor',
    recvEvtOrdersUpdated: 'recv-evt-orders-updated',
    recvEvtFulfillmentUpdated: 'recv-evt-fulfillment-updated',
    // TODO 모바일 관련 로직 src/worker/socket.worker.js, src/worker/SocketWorker.js에
    // 해당 변수를 사용하는 로직이 남아 있어 우선 남겨둠
    subOrdersUpdatedHub: 'sub-orders-updated-hub',
    subOrdersUpdatedDistributor: 'sub-orders-updated-distributor',
    subWorkersFulfillmentHub: 'sub-workers-fulfillment-hub',
    subWorkersFulfillmentDistributor: 'sub-workers-fulfillment-distributor',
};
